import documentsReducer from './reducers';

export { default as documentsActions } from './actions';
export { default as documentsSelectors } from './selectors';

export default documentsReducer;
